import { render, staticRenderFns } from "./AdmitCardPrinting.vue?vue&type=template&id=0f535158&scoped=true"
import script from "./AdmitCardPrinting.vue?vue&type=script&lang=js"
export * from "./AdmitCardPrinting.vue?vue&type=script&lang=js"
import style0 from "./AdmitCardPrinting.vue?vue&type=style&index=0&id=0f535158&prod&scoped=true&lang=css"
import style1 from "./AdmitCardPrinting.vue?vue&type=style&index=1&id=0f535158&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f535158",
  null
  
)

export default component.exports